export default "__VITE_ASSET__BX3CD6OI__"